var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationCompanyCard = function SvgSimpleIllustrationCompanyCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simple-illustration__company-card_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__company-card_svg__st1{fill:#fed607}.simple-illustration__company-card_svg__st2{fill:#780505}.simple-illustration__company-card_svg__st3{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 49.1V20.5h.4c0 1.3 1.2 2.3 2.7 2.3 1.5 0 2.7-1 2.7-2.3v-.4h19.2v.4c0 1.3 1.2 2.3 2.7 2.3 1.5 0 2.7-1 2.7-2.3v-.4h1.8c1.3 0 2.3 1 2.3 2.3v24.3c0 1.3-1 2.3-2.3 2.3l-32.2.1z",
    style: {
      fill: "#722b03"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__company-card_svg__st1",
    d: "M41.3 20.2h5.3v.4c0 1.3-1.2 2.3-2.7 2.3-1.5 0-2.7-1-2.7-2.3l.1-.4zM22 20.2v.4c0 1.3-1.2 2.3-2.7 2.3-1.5 0-2.7-1-2.7-2.3v-.4H22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__company-card_svg__st2",
    d: "M26 20.2h-4v-8c0-1.2 1-2.2 2.2-2.2H39c1.2 0 2.2 1 2.2 2.2v8h-3.8v-4.8c0-1.2-1-2.2-2.2-2.2h-7c-1.2 0-2.2 1-2.2 2.2v4.8zM16.3 20.5V49H13c-1.3 0-2.3-1-2.3-2.3V22.4c0-1.3 1-2.3 2.3-2.3h3.6v.4h-.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__company-card_svg__st3",
    d: "M46.6 20.2h1.8c1.3 0 2.3 1 2.3 2.3v24.3c0 1.3-1 2.3-2.3 2.3H13c-1.3 0-2.3-1-2.3-2.3V22.4c0-1.3 1-2.3 2.3-2.3l33.6.1h0zM16.3 49.1V20.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__company-card_svg__st3",
    d: "M22 20.5c0 1.3-1.2 2.3-2.7 2.3-1.5 0-2.7-1-2.7-2.3M46.6 20.5c0 1.3-1.2 2.3-2.7 2.3-1.5 0-2.7-1-2.7-2.3M22 20v-7.9c0-1.2 1-2.2 2.2-2.2H39c1.2 0 2.2 1 2.2 2.2V20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__company-card_svg__st3",
    d: "M26 20.2v-4.8c0-1.2 1-2.2 2.2-2.2h7c1.2 0 2.2 1 2.2 2.2v4.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m60 38.5-25.1.1c-.7 0-1.3.6-1.3 1.3l.1 13.7c0 .7.6 1.3 1.3 1.3l25.1-.1c.7 0 1.3-.6 1.3-1.3l-.1-13.7c0-.7-.6-1.3-1.3-1.3z",
    style: {
      fill: "#ff7101"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "simple-illustration__company-card_svg__st3",
    d: "m59.8 38.5-24.7.1c-.9 0-1.6.7-1.6 1.6l.1 13.2c0 .9.7 1.6 1.6 1.6l24.7-.1c.9 0 1.6-.7 1.6-1.6L61.4 40c0-.8-.7-1.5-1.6-1.5zM36.2 52.2H40M41.7 52.2h3.8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.9 47.6v-3.1c0-.2-.3-.3-.7-.3h-2.5c-.2 0-.4 0-.5.1l-.8.5c-.1.1-.1.1-.1.2v2.2c0 .1 0 .1.1.2l.6.4c.1.1.3.1.6.1h2.7c.3 0 .6-.2.6-.3z",
    style: {
      fill: "#fbccff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9 43.9H47.5c-.4 0-.7.3-.7.7v2.3c0 .4.3.7.7.7h10.4c.4 0 .7-.3.7-.7v-2.3c0-.4-.3-.7-.7-.7z",
    style: {
      fill: "#002140"
    }
  }));
};
export default SvgSimpleIllustrationCompanyCard;